export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "PHONE NUMBER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["PHONE NUMBER"])},
      "CAPTCHA": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["CAPTCHA"])},
      "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit"])},
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Find ID (e-mail address)"])},
      "my_id_is": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["ID (e-mail address): ", _interpolate(_named("id"))])}
    }
  })
}
